import React, { createContext, useContext, useState } from 'react'
import { User } from 'oidc-client-ts'

import AuthService from '../utils/authService'

interface AuthProviderProps {
  children: React.ReactNode | React.ReactNode[];
}

interface IProfile {
  apellido: string
  documento: string
  esPrimerLogin: string
  id: string
  name: string
  nombre: string
  pais: string
  persona: string
  preferred_username: string
  si: string
  state: string
  sub: string
}

interface AuthContextProps {
  signinRedirectCallback: () => Promise<User>;
  logout: () => void;
  signoutRedirectCallback: () => void;
  isAuthenticated: () => boolean;
  signinRedirect: () => void;
  signinSilentCallback: () => void;
  createSigninRequest: () => void;
  hasAuthParams: () => boolean;
  getUser: () => Promise<User>;
  isAuthenticatedUserEndpoint: () => Promise<boolean>;
  getProfile: () => IProfile;
}

export const AuthContext = createContext<AuthContextProps>(null)

export function AuthProvider({ children }: AuthProviderProps) {
  const [authService] = useState(() => new AuthService())
  return (
    <AuthContext.Provider value={authService}>{children}</AuthContext.Provider>
  )
}

export const useAuthContext = () => {
  const context = useContext(AuthContext)
  if (context === undefined) {
    throw new Error('AuthContext must be used within a AuthProvider')
  }
  return context
}

export const AuthConsumer = AuthContext.Consumer
